// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab96f259","455":"92f38483","867":"84591b1d","977":"afaa7fe3"}[chunkId] + ".chunk.js";
};